import { RequestMethod } from "@/types/request-method";
import { API_URL } from "@/config/urls";
import { Login } from "@/types/login";
import axios from "axios";
import store from "@/store";

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// If a response 401s, we assume the token is invalid and logout
apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      store.dispatch("autoLogout");
    }
    return Promise.reject(error);
  },
);

export default {
  request(url: string, method: RequestMethod, params?: object, data?: object, basicAuth?: Login) {
    let authorization: string;

    if (basicAuth) {
      authorization = `Basic ${btoa(`${basicAuth.username}:${basicAuth.password}`)}`;
    } else {
      authorization = `Bearer ${localStorage.getItem("token")}`;
    }

    return apiClient.request({
      url,
      method,
      params,
      data,
      headers: {
        Authorization: authorization,
      },
    });
  },
};
